import { createSelector } from 'reselect';

const getOccupancies = state => state.occupancy.data;

export const getOccupancyForRoom = room =>
  createSelector(
    [getOccupancies],
    occupancies =>
      occupancies.find(occupancy => occupancy.roomId === room.roomId) || {
        arrival: {},
        stay: {},
        departure: {}
      }
  );



// WEBPACK FOOTER //
// ./src/rooms/occupancy/selectors.js